import {ref, computed} from "vue";
import {useStore} from "vuex";
import {useVuelidate} from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";

export function usePartnerCategory() {
    const store = useStore();

    const category = computed(() => store.getters.getCurrentPartnerCategory);
    const lang = computed(() => store.getters.getLang);
    const nameField = computed(() => `name_${lang.value}`);

    const form = ref({
        name_ru: '',
        name_en: ''
    });

    const rules = computed(() => ({
        [nameField.value]: {required: helpers.withMessage('Поле обязательно для заполнения', required)},
    }));

    const v$ = useVuelidate(rules, form);

    const loadPartnerCategory = async (id) => {
        await store.dispatch('fetchPartnerCategory', id);
    };

    const updatePartnerCategory = async (id, body) => {
        const result = await v$.value.$validate();
        if (!result) {
            return;
        }

        await store.dispatch('fetchUpdatePartnerCategory', {
            id,
            body
        });
    };

    const destroyPartnerCategory = async (id) => {
        await store.dispatch('fetchDestroyPartnerCategory', {id});
    }

    return {category, form, loadPartnerCategory, updatePartnerCategory, v$, destroyPartnerCategory};
}